<script>

import ActionApi from '@api/ActionApi';
import ProjectApi from '@api/ProjectApi';

export default {

    props: {
        action: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            starting: true,
            loading: false,
            error: null,
            integration: null,
            params: {},
        }
    },

    methods: {

        connectAction() {
            this.$store.commit('showModal', false);
            this.$router.push({ name: 'settings-integrations' });
        },

        saveAction() {
            this.loading = true
            ActionApi.updateAction(this.action.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setAction', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        testAction() {
            this.loading = true;
            ActionApi.testAction(this.action.id, this.action.type, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.sent'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false
                    this.error = error.response.data.message;
                });
        },

        getIntegration(type) {
            this.starting = true;
            ProjectApi.getIntegration(this.project.id, type, { subloads: true })
                .then((response) => {
                    this.starting = false;
                    this.integration = response.data.data;
                }, () => {
                    this.starting = false;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    }

}

</script>